export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/index-legacy.0a65cff9.worker.js");
}
